import {useState} from 'react';

import {CommentsMemoryRepository} from '../../repositories/comments-memory-repository';

function useCommentsFromMemory() {
  const [commentsFromMemory, setCommentsFromMemory] = useState([]);

  CommentsMemoryRepository.subscribe((_, value) => setCommentsFromMemory(value));

  return {
    commentsFromMemory
  };
}

export {
  useCommentsFromMemory
};
